import React from "react";
import { defineMessages, MessageDescriptor, useIntl } from "react-intl";
import { useUrl } from "../../../../../hooks/usePage";
import { Pagetype } from "../../../../../interfaces/Config";
import { ROUTES } from "../../const";

import "./PadCreationToast.scss";

type Props = {
    toastPadTitle: MessageDescriptor;
    padId?: string;
    padName: string;
    workshopId?: string;
    eventType: "error" | "success";
};

const PadCreationToast = ({
    padId,
    padName,
    workshopId,
    eventType,
    toastPadTitle,
}: Props) => {
    const intl = useIntl();
    const basepath = useUrl(Pagetype.WORKMODE_WORKSHOP);

    return (
        <div className="pad-creation-toast">
            <p>
                {intl.formatMessage(toastPadTitle, {
                    padName: padName,
                })}
            </p>
            {eventType === "success" && padId && workshopId && (
                <a
                    href={`${basepath}/${ROUTES.padPreview}/${workshopId}/${padId}`}
                >
                    {intl.formatMessage(messages.sessionOpen)}
                </a>
            )}
        </div>
    );
};

export default PadCreationToast;

const messages = defineMessages({
    sessionOpen: {
        id: "workshop-session-open",
        defaultMessage: "Open",
    },
});
